export const PERMS = {
    READ: 'report_cost_center_results.read',
    UPDATE: 'report_cost_center_results.update',
    DELETE: 'report_cost_center_results.delete',
    CREATE: 'report_cost_center_results.create',
    EXPORT: 'report_cost_center_results.export',
}
